(() => {
  const supportsIO = "IntersectionObserver" in window;

  function initReveal() {
    const els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;

    if (!supportsIO) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        }
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );

    els.forEach((el) => io.observe(el));
  }

  function initStickyHeader() {
    const header = document.querySelector("[data-site-header]");
    if (!header) return;
    const update = () => {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
  }

  function initMobileNav() {
    const trigger = document.querySelector("[data-nav-toggle]");
    const drawer = document.querySelector("[data-nav-drawer]");
    if (!trigger || !drawer) return;
    trigger.addEventListener("click", () => {
      const open = drawer.toggleAttribute("open");
      trigger.setAttribute("aria-expanded", String(open));
      document.documentElement.style.overflow = open ? "hidden" : "";
    });
    drawer.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", () => {
        drawer.removeAttribute("open");
        trigger.setAttribute("aria-expanded", "false");
        document.documentElement.style.overflow = "";
      }),
    );
  }

  function initMarquees() {
    document.querySelectorAll("[data-marquee]").forEach((m) => {
      const track = m.querySelector(".marquee__track");
      if (!track) return;
      const clone = track.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      m.appendChild(clone);
    });
  }

  function initParallax() {
    const els = document.querySelectorAll("[data-parallax]");
    if (!els.length) return;
    const onScroll = () => {
      for (const el of els) {
        const rect = el.getBoundingClientRect();
        const speed = parseFloat(el.dataset.parallax) || 0.15;
        const offset = (rect.top - window.innerHeight / 2) * speed;
        el.style.setProperty("--parallax-y", `${offset.toFixed(1)}px`);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  function initTilt() {
    const cards = document.querySelectorAll("[data-tilt]");
    if (!cards.length) return;
    cards.forEach((card) => {
      card.addEventListener("mousemove", (e) => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty("--tilt-x", `${(-y * 4).toFixed(2)}deg`);
        card.style.setProperty("--tilt-y", `${(x * 4).toFixed(2)}deg`);
      });
      card.addEventListener("mouseleave", () => {
        card.style.setProperty("--tilt-x", "0deg");
        card.style.setProperty("--tilt-y", "0deg");
      });
    });
  }

  const ready = () => {
    initReveal();
    initStickyHeader();
    initMobileNav();
    initMarquees();
    initParallax();
    initTilt();
  };

  if (document.readyState !== "loading") ready();
  else document.addEventListener("DOMContentLoaded", ready);
})();
